import { Box, createStyles, Table } from "@mantine/core";
import ActivityLibraryTableRow from "../ActivityLibraryTableRow";
import RecordNotFound from "../RecordNotFound";

const useStyles = createStyles(() => ({
  wrap: {
    border: "1px solid var(--app-border)",
    borderRadius: 12,
    overflow: "hidden",
  },
  table: {
    backgroundColor: "var(--app-surface) !important",
    fontFamily: "Inter !important",
    "& thead tr": {
      background: "#000 !important",
    },
    "& thead th": {
      color: "#fff !important",
      fontFamily: "Inter !important",
      fontSize: "13px !important",
      fontWeight: "600 !important",
      padding: "16px !important",
      textAlign: "left",
    },
    "& tbody td": {
      fontFamily: "Inter !important",
      padding: "16px !important",
      borderBottom: "1px solid var(--app-border) !important",
      borderRight: "none !important",
    },
    "& tbody tr:hover": {
      backgroundColor: "var(--app-surface-2) !important",
    },
  },
}));

// Matches the mockup's settingsView() (Item | Activity Type | Actions, no
// layer/section grouping, no vertical column borders, black header row,
// white surface background) plus a Status column added per ticket (OD-1193)
// so admins can toggle an activity active/inactive right from the table.
const ActivityLibraryTable = ({ activities, onEdit, onDelete, onToggle }) => {
  const { classes } = useStyles();
  if (!activities?.length) return <RecordNotFound />;

  const rows = activities.slice().sort((a, b) => (a.order ?? 0) - (b.order ?? 0));

  return (
    <Box className={classes.wrap}>
      <Table className={classes.table} highlightOnHover fontSize="sm" verticalSpacing="md">
        <thead>
          <tr>
            <th>Item</th>
            <th style={{ width: 170 }}>Activity Type</th>
            <th style={{ width: 110 }}>Status</th>
            <th style={{ width: 90, textAlign: "right" }}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((row) => (
            <ActivityLibraryTableRow key={row.id} row={row} onEdit={onEdit} onDelete={onDelete} onToggle={onToggle} />
          ))}
        </tbody>
      </Table>
    </Box>
  );
};

export default ActivityLibraryTable;
